<template>
  <div id="ViewGradesDetail" class="wrap">
    <div class="maxContainer">
      <div class="offset-md-3 col-md-6 offset-sm-2 col-sm-8">
        <div @click="backDesktop" class="headerFake__back">
          <a class="headerFake__backLink">
            <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
            <span class="headerFake__backText">Back</span>
          </a>
        </div>
      </div>
      <!-- College Header -->
      <v-app-bar  v-if="college" class="grey lighten-3 hidden-md-and-up "  fixed  elevate-on-scroll  >
        <v-layout column>
          <v-toolbar-title class="light-blue--text text--darken-3 ">{{college.college_name}}</v-toolbar-title>
            <span class="caption mr-2"> Degree:
              <span v-if="college.degree === 'In Progress'" class=" caption  amber--text text--darken-3 ">In Progress</span>
              <span v-else-if="college.degree === 'Completed'" class="caption  green--text ">{{college.college_degree_awarded}} </span>
            </span>
        </v-layout>
        <v-spacer></v-spacer>
        <v-btn @click="showEditCollegeDialog(college.id)" icon small  ><v-icon color=" "  >mdi-pencil</v-icon></v-btn>
        <RemoveCollegeDialog :college="college"/>
      </v-app-bar>




    <div class="offset-md-3 col-md-6 offset-sm-2 col-sm-8">


    <v-card flat v-if="college">
        <v-card-title class="hidden-sm-and-down pl-0">
          <v-layout column>
          <v-toolbar-title class="light-blue--text text--darken-3 headline">{{college.college_name}}</v-toolbar-title>
            <span class="caption mr-2"> Degree:
              <span v-if="college.degree === 'In Progress'" class=" caption  amber--text text--darken-3 ">In Progress</span>
              <span v-else-if="college.degree === 'Completed'" class="caption  green--text ">{{college.college_degree_awarded}} </span>
            </span>
        </v-layout>
        <v-spacer></v-spacer>
        <v-btn @click="showEditCollegeDialog(college.id)" icon small  ><v-icon color=" "  >mdi-pencil</v-icon></v-btn>
        <RemoveCollegeDialog :college="college"/>
        </v-card-title>

            <v-tabs hide-slider v-model="tab" grow class=" " >
              <v-tab active-class="grey darken-3 white--text  font-weight-bold" style="marginLeft:0px;">
                Semesters
              </v-tab>

              <v-tab active-class="grey darken-3 white--text  font-weight-bold">
                AP Courses
              </v-tab>

              <v-tab active-class="grey darken-3 white--text  font-weight-bold">
                CLEP
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" >
              <!-- Semesters  -->
                <v-tab-item style="marginBottom:90px">
                  <v-layout  align-center justify-center style="marginTop:20px">
                      <v-btn  @click="showAddSemesterDialog(college.id)" class="mr-1 elevation-5" block  dark large  color="#D49129">Add Semester</v-btn>
                  </v-layout>
                  <v-container v-if="college.semesters.length === 0" class="pb-1 px-4 mt-4 ">
                    <p class=" text-center body-1  ">Add a semester to input your courses</p>
                  </v-container>
                  <!-- Semesters -->
                    <v-expansion-panels  v-for="semester in college.semesters"
                      :v-model="semester.semester_term"
                      :key="semester.id"
                      class=" mt-3"
                      style="borderRadius:5px; marginTop:30px"
                      id="buttonShadow" >
                        <v-expansion-panel class="mt-2 elevation-0"  >
                          <v-expansion-panel-header class="grey lighten-3"  >
                            <v-layout column>
                              <v-layout row align-center>
                                <span class="title font-weight-medium light-blue--text text--darken-3">{{ semester.semester_academic_status }} Year <span class="ml-1">{{semester.semester_year | moment("YYYY")}}</span> </span>
                                  <v-layout row ml-2>
                                    <v-btn @click="showEditSemesterDialog(college,semester)" icon small   color=" ml-0"> <v-icon >mdi-pencil</v-icon></v-btn>
                                    <RemoveSemesterDialog :college="college" :semester="semester"/>
                                  </v-layout>
                              </v-layout>
                              <v-layout row  align-center>
                                <span class="font-weight-regular"> {{semester.semester_term}} Semester -</span>
                                <span v-bind:class="{'green--text' : semester.semester_completion_status === 'Completed', 'amber--text text--darken-3' : semester.semester_completion_status === 'In Progress', 'light-blue--text text--darken-3' : semester.semester_completion_status === 'Planned' }" class="body-1 ml-1"> {{semester.semester_completion_status}}</span>
                              </v-layout>
                            </v-layout>

                          </v-expansion-panel-header>
                            <v-expansion-panel-content   >

                             <v-layout class="mx-3"> <v-btn @click="showAddCourse(college,semester)" class="mb-0  mt-4 elevation-4 btn"  color="green"  large block dark>Add Course</v-btn></v-layout>
                                <v-layout justify-center v-if="semester.courses.length === 0" mt-4>
                                    <span  class="grey--text text-center">No Courses Listed</span>
                                </v-layout>

                                <v-list two-line class="pt-0 mt-2" >
                                  <v-list-item-group  >
                                    <template v-for="(course, index) in semester.courses" :ripple="false" >
                                      <v-list-item :key="course.id"  flat>

                                          <v-list-item-content>
                                            <v-list-item-title :ripple="false">
                                              <v-layout align-center>
                                                <v-icon v-if="course.online_course !== '' && course.online_course !== null && course.online_course !== undefined" small class="mr-1">mdi-laptop</v-icon>
                                                {{ course.course_name }}
                                                <span v-if="semester.semester_completion_status === 'In Progress'" class="caption warning--text "> <span class="black--text ">:</span>  Grade pending </span>
                                                <span @click="showAddGrade(college,semester,course)" v-if="semester.semester_completion_status === 'Completed' && course.course_grade === '' && course.pass_fail_grade === ''" class="green--text  "  > <span class="black--text " style="textDecoration:none">:</span> <span style="textDecoration:underline">Add Grade</span></span>
                                                <span v-if="course.course_grade !== '' && semester.semester_completion_status === 'Completed' && (course.pass_fail_course === false || course.pass_fail_course === '' )" class=" green--text font-weight-medium"> <span class="black--text ">:</span> {{ course.course_grade }} </span>
                                                <span v-if="course.pass_fail_grade !== '' && course.pass_fail_grade === 'true' && semester.semester_completion_status === 'Completed'" class="ml-1 green--text"> <span class="">-</span> Pass </span>
                                                <span v-if="course.pass_fail_grade !== '' && course.pass_fail_grade === 'false' && semester.semester_completion_status === 'Completed'" class="ml-1  red--text"> <span class="">-</span> Fail </span>
                                              </v-layout>

                                            </v-list-item-title>
                                            <!-- Course Credits -->
                                            <v-list-item-subtitle v-if="college.college_term_system === 'Semester' || college.college_term_system === 'Trimester'" class="text--primary " >
                                              <span >{{ course.course_credits }} credits  </span>
                                              <span v-if="course.course_lab === 'true' " class="text--primary " > - with lab</span>
                                              <span v-if="course.course_lab === 'false' "  class="text--primary " > - without lab</span>
                                            </v-list-item-subtitle>
                                            <!-- Quarter Credits -->
                                            <v-list-item-subtitle v-if="college.college_term_system === 'Quarter'" class="text--primary " >
                                              <span v-if="course.quarter_credits !== ''">{{ course.quarter_credits }} quarter credits  </span>
                                              <span v-if="course.course_lab === 'true' " class="text--primary " > - with lab</span>
                                              <span v-if="course.course_lab === 'false' "  class="text--primary " > - without lab</span>
                                            </v-list-item-subtitle>

                                            <!-- Lab Credits -->
                                            <v-list-item-subtitle  v-if="(college.college_term_system === 'Semester' || college.college_term_system === 'Trimester') && course.lab_credits !== '' "  class="text--primary " >
                                              Lab credits: {{course.lab_credits }}
                                              <span v-if="course.lab_grade !== '' && semester.semester_completion_status === 'Completed'"  class="text--primary " > / Lab grade:<span class="blue--text text--darken-3"> {{course.lab_grade}}</span></span>
                                            </v-list-item-subtitle>

                                            <!-- Lab Quarter Credits -->
                                            <v-list-item-subtitle  v-if="college.college_term_system === 'Quarter' && course.lab_quarter_credits !== '' "  class="text--primary " >
                                              Lab quarter credits: {{course.lab_quarter_credits }}
                                              <span v-if="course.lab_grade !== '' && semester.semester_completion_status === 'Completed'"  class="text--primary " > / Lab grade:<span   class="blue--text text--darken-3"> {{course.lab_grade}}</span></span>
                                            </v-list-item-subtitle>
                                            <!-- {{course}} -->
                                            <v-layout v-if="findCourseSubject(course.course_id) || course.course_subject_category">
                                              <span class="caption grey--text">CASPA Subject: </span>
                                              <span class="caption ml-1 grey--text" v-if="findCourseSubject(course.course_id)"> {{findCourseSubject(course.course_id)}}</span>
                                              <span class="caption ml-1 grey--text" v-else> {{course.course_subject_category}}</span>
                                            </v-layout>
                                          </v-list-item-content>

                                          <v-list-item-action class="mb-0">

                                            <RemoveCourseDialog :course="course" :semester="semester" :college="college"/>


                                          </v-list-item-action>

                                      </v-list-item>


                                      <v-divider
                                        v-if="index + 1 < semester.courses.length"
                                        :key="index"
                                      ></v-divider>
                                    </template>

                                  </v-list-item-group>
                                </v-list>

                          </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>

                </v-tab-item>

                <!-- AP Courses -->
                <v-tab-item>
                  <v-layout  align-center justify-center style="marginTop:20px">
                      <v-btn  @click="addApCourse(college)" class="mr-1 elevation-5" block  dark large color="#D49129">Add AP Course</v-btn>
                  </v-layout>
                  <v-container v-if="college.apcourses.length === 0 || college.apcourses === undefined " class="pb-1 px-4 mt-4 ">
                    <p class=" text-center body-1  ">Add an AP course if applicable </p>
                  </v-container>

                  <v-list two-line class="pt-3" >
                    <v-list-item-group  >
                      <template v-for="(course, index) in college.apcourses">
                        <v-list-item :key="course.id" >

                            <v-list-item-content>
                              <v-list-item-title >  {{ course.course_name }}  </v-list-item-title>
                              <!-- Ap Course Grade -->
                              <v-list-item-subtitle class="text--primary " >
                                <span class="text--primary">Score: <span v-if="course.course_grade !== ''" class="  ml-1">{{ course.course_grade }} </span></span>

                              </v-list-item-subtitle>



                            </v-list-item-content>

                            <v-list-item-action class="mb-0">

                                <RemoveApCourse :course="course"  :college="college"/>


                            </v-list-item-action>

                        </v-list-item>


                        <v-divider
                          v-if="index + 1 < college.apcourses.length"
                          :key="index"
                          class="mx-3"
                        ></v-divider>
                      </template>

                    </v-list-item-group>
                  </v-list>

                </v-tab-item>

                <!-- CLEP -->
                <v-tab-item>
                  <v-layout  align-center justify-center style="marginTop:20px">
                      <v-btn  @click="addClepCourse(college)"  class="mr-1 elevation-5" block  dark large color="#D49129">Add CLEP</v-btn>
                  </v-layout>
                  <v-container v-if="college.clepcourses.length === 0 || college.clepcourses === undefined " class="pb-1 px-4 mt-4 ">
                    <p class=" text-center body-1  ">Add CLEP credits if applicable </p>
                  </v-container>

                  <v-list two-line class="pt-3" >
                      <v-list-item-group  >
                        <template v-for="(course, index) in college.clepcourses">
                          <v-list-item :key="course.id" >

                              <v-list-item-content>
                                <v-list-item-title >  {{ course.course_name }}  </v-list-item-title>
                                <!-- Ap Course Grade -->
                                <v-list-item-subtitle class="text--primary " >
                                  <span class="text--primary">Score: <span v-if="course.course_grade !== ''" class=" ml-1" v-bind:class="{'green--text' : course.course_grade === 'Pass', 'red--text' : course.course_grade === 'Fail'}">{{ course.course_grade }} </span></span>

                                </v-list-item-subtitle>



                              </v-list-item-content>

                              <v-list-item-action class="mb-0">

                                <RemoveClepCourse :course="course"  :college="college"/>


                              </v-list-item-action>

                          </v-list-item>


                          <v-divider
                            v-if="index + 1 < college.clepcourses.length"
                            :key="index"
                            class="mx-3"
                          ></v-divider>
                        </template>

                      </v-list-item-group>
                    </v-list>

                </v-tab-item>
            </v-tabs-items>
    </v-card>

     </div>
    <!-- Back Button -->
    <v-btn class="mr-4 ml-2 fixed elevation-0" style="zIndex:1" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>
  </div>
  </div>

</template>

<script>
  export default {
    name: 'ViewGradesDetail',
     data() {
      return {
        tab: null,
        modal: false,
        alert: false,
        AddCourseDialog : false,

          selected: [2],


      }
    },
    methods: {
      back() {
        this.$router.push('/dashboard/mygrades');
      },
      backDesktop () {
        this.$router.push('/dashboard');
      },
      showAddCourse(college, semester) {
        this.$router.push('/dashboard/mygrades/' + college.id + '/' + semester.id + '/addcourse');
      },
      showEditCollegeDialog(college) {
         this.$router.push('/dashboard/mygrades/editcollege/' + college)
      },
      showAddSemesterDialog(college) {
         this.$router.push('/dashboard/mygrades/addsemester/' + college)
      },
      showEditSemesterDialog(college, semester) {
         this.$router.push('/dashboard/mygrades/' + college.id + '/' + semester.id + '/editsemester')
      },
      showAddGrade(college,semester,course) {
         this.$router.push('/dashboard/mygrades/' + college.id + '/' + semester.id + '/' + course.id + '/addgrade');
      },
      addApCourse(college) {
        this.$router.push('/dashboard/mygrades/addapcourse' + '/' + college.id );
      },
      addClepCourse(college) {

        this.$router.push('/dashboard/mygrades/addclepcourse' + '/' + college.id );
      },
      findCourseSubject(courseId) {

        let subject

        this.courses.find((course )=> {
          if(course.id === courseId) {
            subject = course.course_subject
          }
        })
        return subject
      },
    },
    computed : {
      id () {
        return this.$route.params.id
      },
      college() {
      return this.$store.getters.loadedCollege(this.id);
      },
      user () {
        return this.$store.getters.user
      },
      userColleges () {
        return this.$store.getters.userColleges
      },
      schools() {
        return this.$store.getters.loadedSchools
      },
      courses() {
        return this.$store.getters.loadedCourses
      }

    },
  }
</script>

<style scoped>


.closeButton {
  bottom: 0;
  top:695px;
  background-color: white;

}

#headerToolbar {
  position: sticky;
  box-shadow: 0 10px 30px -10px #11111130;
}

 .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;

  }

#buttonShadow {
  box-shadow: 0 10px 30px -10px #00000030;
}
@media (min-width: 960px) {
    .fixed {
        margin-bottom: 110px;
    }
}

.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}


.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}

.wrap {
  margin-top:8vh !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Grades/ViewGradesDetail.vue